import { Outlet } from 'react-router-dom'

export default function SettingsLayout() {
  return (
    <div className="w-full overflow-auto p-4 md:min-h-screen md:p-6">
      <div className="mx-auto max-w-3xl">
        <Outlet />
      </div>
    </div>
  )
}
